import { createContext } from "react";
import { initialState } from "./reducer";

const StoreContext=createContext(initialState);

export default StoreContext;